import { emptyToastMessage } from 'consts/common';
import React, { createContext, useState, useContext } from 'react';


const SnackbarContext = createContext(undefined);

export const SnackbarProvider = ({ children }) => {
  const [message, setMessage] = useState(emptyToastMessage);

  return (
    <SnackbarContext.Provider value={{ message, setMessage }}>
      {children}
    </SnackbarContext.Provider>
  );
};

export const useSnackbar = () => {
  const context = useContext(SnackbarContext);
  if (context === undefined) {
    throw new Error('useSnackbar must be used within a SnackbarProvider');
  }
  return context;
};